import { Button, Popover } from '@mantine/core';
import { useUnit } from 'effector-react';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { gameModel, ONBOARDING_STEPS } from 'entities/game';
import { ONBOARDING_POPOVER_TEXTS } from '../../config';
import { interactiveElementModel } from '../../model';
import NextIcon from '../assets/next-icon.svg?react';
import SkipIcon from '../assets/skip-icon.svg?react';
import cls from './interactive-element-onboarding-popover.module.scss';

export const InteractiveElementOnboardingPopover = ({ children }: PropsWithChildren) => {
	const { t } = useTranslation();

	const [active, step, skip, next, enableOnboardingCalculator] = useUnit([
		gameModel.$isOnboarding,
		gameModel.$onboardingStep,
		gameModel.skipOnboarding,
		gameModel.changeNextOnboardingStep,
		interactiveElementModel.$enableOnboardingCalculator,
	]);

	const isBetButtonOnboarding = step === ONBOARDING_STEPS.BET_BUTTON;

	return (
		<Popover
			withArrow={!enableOnboardingCalculator}
			zIndex={enableOnboardingCalculator ? 2000 : 300}
			opened={active}
		>
			<Popover.Target>
				<div className={cls.interactiveElementOnboardingPopoverTarget}>{children}</div>
			</Popover.Target>
			<Popover.Dropdown
				data-calculator={enableOnboardingCalculator || undefined}
				className={cls.interactiveElementOnboardingPopover}
			>
				<div className={cls.interactiveElementOnboardingPopoverContent}>
					{ONBOARDING_POPOVER_TEXTS[step].map((text) => (
						<p key={text}>{t(`onboarding.${text}`)}</p>
					))}
				</div>
				<div className={cls.interactiveElementOnboardingPopoverButtons}>
					{!isBetButtonOnboarding && (
						<Button
							variant='standard'
							rightSection={
								<SkipIcon
									width={22}
									height={32}
								/>
							}
							classNames={{
								root: cls.interactiveElementOnboardingPopoverButton,
								label: cls.interactiveElementOnboardingPopoverButtonLabel,
							}}
							onClick={skip}
						>
							{t('onboarding.skip')}
						</Button>
					)}
					<Button
						variant='standard'
						rightSection={
							<NextIcon
								width={22}
								height={32}
							/>
						}
						classNames={{
							root: cls.interactiveElementOnboardingPopoverButton,
							label: cls.interactiveElementOnboardingPopoverButtonLabel,
						}}
						onClick={next}
					>
						{isBetButtonOnboarding ? t('onboarding.start-playing') : t('onboarding.next')}
					</Button>
				</div>
			</Popover.Dropdown>
		</Popover>
	);
};
